import { TextField, Box, Typography, Stack, Select, MenuItem, InputLabel, FormControl, Button, Tooltip, IconButton } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { axiosGetCall, axiosPostCall, axiosPatchCall } from 'src/services/apisCall';

import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import dayjs from 'dayjs';
import { LoadingButton } from '@mui/lab';
import Logger from '../../../lib/Logger';
import Iconify from '../../../components/iconify';

const logger = new Logger("asetting")

const BasicDatePicker = ({ value, onChange, dateError, resetError, label }) => {
    const [, setOpen] = useState(false);
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} >
            <TimePicker views={['hours']}
                label={label}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                slotProps={{
                    textField: {
                        size: 'small',
                        error: Boolean(dateError),
                        helperText: Boolean(dateError) && dateError,
                        onClick: () => resetError()
                    },
                    actionBar: {
                        actions: ['today', 'clear'],
                    },
                }}
                ampm={true}
                value={value} onChange={(newValue) => onChange(newValue)}
            />
        </LocalizationProvider>
    )
}

const requestList = [
    { label: "Self", value: "U" },
    { label: "Downline", value: "D" },
    { label: "Hierarchy", value: "H" }
]

const dndStatusList = [
    { label: "On", value: "1" },
    { label: "Off", value: "0" }
]

const BroadcastSettings = ({ user }) => {
    const inputSx = {
        color: "grey.900",
        borderColor: 'grey.700',
        borderRadius: "6px",
    };

    const [anouncementUploadLimit, setAnouncementUploadLimit] = useState(0);
    const [uploadDirectAmount, setUploadDirectAmount] = useState(0);
    const [uploadHirarchyAmount, setuploadHirarchyAmount] = useState(0);
    const [callWindowRequestFor, setCallWindowRequestFor] = useState("U");
    const [uploadLimitRequestFor, setUpdateLimitRequestFor] = useState("U");
    const [uploadDirectAmountRequestFor, setUploadDirectAmountRequestFor] = useState("U");
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [startDateError, setStartDateError] = useState("");
    const [endDateError, setEndDateError] = useState("");
    const [callWindowloader, setCallWindowLoader] = useState(false);
    const [announcementLimitLoader, setAnnouncementLoader] = useState(false);
    const [load, setLoad] = useState(false);

    const updateAnnouncementUploadLimit = async () => {
        try {
            setAnnouncementLoader(true);
            const payload = {
                userId: user?.voiceInfo?.userId,
                action: "updateAnnouncementUploadLimit",
                announcementLimit: parseInt(anouncementUploadLimit),
                requestFor: "U",
            }
            if (user?.voiceInfo?.userType === "reseller") {
                payload.requestFor = uploadLimitRequestFor;
            }
            await axiosPatchCall("updateProfileSetting", payload);
            setAnnouncementLoader(false);
            renderSuccessMessage("Success");
        } catch (error) {
            logger.error(error)
            setAnnouncementLoader(false);
            renderErrorMessage(error.message)
        }
    }

    const updateACallWindow = async () => {
        try {
            if (!startTime) {
                return setStartDateError("Start date is required");
            }
            if (!endTime) {
                return setEndDateError("End date is required")
            }
            const startHour = dayjs(startTime).hour();
            const endHour = dayjs(endTime).hour();

            if (startHour > endHour) {
                return setEndDateError("End date must be greater than the Start date")
            }

            if (startHour === endHour && startHour !== 0) {
                return setEndDateError("Start Time and End Time not be same")
            }
            const payload = {
                userId: user?.voiceInfo?.userId,
                action: "updateCallWindow",
                callWindowStart: startHour,
                callWindowEnd: endHour,
                requestFor: "U",
            }
            if (user?.voiceInfo?.userType === "reseller") {
                payload.requestFor = callWindowRequestFor;
            }
            setCallWindowLoader(true);
            await axiosPatchCall("updateProfileSetting", payload);
            setCallWindowLoader(false);
            renderSuccessMessage("Success");
        }
        catch (error) {
            logger.error(error);
            setCallWindowLoader(false);
            renderErrorMessage(error.message)
        }
    }

    const updateDirectAmount = async () => {
        try {
            
            const payload = {
                userId: user?.voiceInfo?.userId,
                action: "updateDirectAmountAssignX",
                directAmountX: parseInt(uploadDirectAmount),
                requestFor: "U",
            }
            if (user?.voiceInfo?.userType === "reseller") {
                payload.requestFor = callWindowRequestFor;
            }
            setCallWindowLoader(true);
            await axiosPatchCall("updateProfileSetting", payload);
            setCallWindowLoader(false);
            renderSuccessMessage("Success");
        }
        catch (error) {
            logger.error(error);
            setCallWindowLoader(false);
            renderErrorMessage(error.message)
        }
    }

    const updateHirarchyAmount = async () => {
        try {
            const payload = {
                userId: user?.voiceInfo?.userId,
                action: "updateHiercharyAmountAssignX",
                hierarchyAmountX: parseInt(uploadHirarchyAmount),
                requestFor: "H",
            }

            setCallWindowLoader(true);
            await axiosPatchCall("updateProfileSetting", payload);
            setCallWindowLoader(false);
            renderSuccessMessage("Success");
        }
        catch (error) {
            logger.error(error);
            setCallWindowLoader(false);
            renderErrorMessage(error.message)
        }
    }

    const handleReset = async (type) => {
        let payload = {
            userId: user?.voiceInfo?.userId,
            action: "resetSetting",
            resetActionType: "",
            requestFor: "U"
        }

        if (type === "announcementLimit") {
            payload.resetActionType = "updateAnnouncementUploadLimit";
            payload.requestFor = uploadLimitRequestFor;
        }

        if (type === "callWindow") {
            payload.resetActionType = "updateCallWindow";
            payload.requestFor = callWindowRequestFor;
        }

        if (type === "directAmountAssignment") {
            payload.resetActionType = "updateDirectAmountAssignment";
            payload.requestFor = uploadLimitRequestFor;
        }

        if (type === "hirarchyAmountAssignment") {
            payload.resetActionType = "updateHirarchyAmountAssignment";
            payload.requestFor = uploadLimitRequestFor;
        }
        try {
            await axiosPatchCall("updateProfileSetting", payload)
            setLoad((prev) => !prev);
        } catch (error) {
            logger.error(error);
            setAnswerPercentLoader(false);
            renderErrorMessage(error.message);
        }
    }

    const handleSubmit = async (type) => {
        if (type === "announcementLimit") {
            await updateAnnouncementUploadLimit();
        }

        if (type === "callWindow") {
            await updateACallWindow();
        }

        if (type === "directAmountAssignment") {
            await updateDirectAmount();
        }

        if (type === "hirarchyAmountAssignment") {
            await updateHirarchyAmount();
        }
    }

    const resetStartTimeError = useMemo(() => {
        return () => {
            setStartDateError("");
        };
    }, []);

    const resetEndTimeError = useMemo(() => {
        return () => {
            setEndDateError("")
        }
    }, [])

    const fetchSettingDetails = async () => {
        try {
            const params = { requestUserId: user?.voiceInfo?.userId, requestName: "all" }
            const { data = {} } = await axiosGetCall("getUserSettingsInfo", { ...params });
            const { callWindowStartTime, callWindowEndTime, announcementUploadLimit, directAmountAssignX, hierarchyAmountAssignX} = data;
            setUploadDirectAmount(directAmountAssignX)
            setuploadHirarchyAmount(hierarchyAmountAssignX);
            
         
            const currentDate = dayjs();
            const startTime = currentDate.hour(callWindowStartTime).minute(0).second(0).millisecond(0);
            const endTime = currentDate.hour(callWindowEndTime).minute(0).second(0).millisecond(0);
            setAnouncementUploadLimit(parseInt(announcementUploadLimit));

            setStartTime(startTime);
            setEndTime(endTime);
        } catch (error) {
            logger.error(error);
        }
    }

    useEffect(() => {
        fetchSettingDetails();
    }, [load])
    
    return (
        <>
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                mt: "10px",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "6px",
                    mb: "15px",
                }}
            >
                <Typography>Call Window</Typography>
                <Box sx={{ 
                    border: "0.5px dashed",
                    borderColor: "gray.400",
                    borderRadius:"7px",
                    padding: "12px",
                    paddingTop: "14px"
                }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "16px",
                    }}
                >
                    <BasicDatePicker
                        label={"Start Time"}
                        value={startTime}
                        onChange={setStartTime}
                        dateError={startDateError}
                        resetError={resetStartTimeError}
                    />
                    <BasicDatePicker
                        label={"End Time"}
                        value={endTime}
                        onChange={setEndTime}
                        dateError={endDateError}
                        resetError={resetEndTimeError}
                    />
                    {user?.voiceInfo?.userType !== "reseller" && (<Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Stack direction={"row"} gap={1}>
                            <IconButton onClick={() => handleReset("callWindow")}>
                                <Iconify icon="ix:reset" />
                            </IconButton>
                            <LoadingButton
                                loading={callWindowloader}
                                variant="contained"
                                sx={{ width: "100px" }}
                                onClick={() => handleSubmit("callWindow")}
                            >
                                Submit
                            </LoadingButton>
                        </Stack>
                    </Box>)}
                </Box>
                <Stack width={"100%"} direction={"row"} alignItems={"center"} >
                    {user?.voiceInfo?.userType === "reseller" && (
                        <Stack
                            gap={2}
                            direction={"row"}
                            width={"100%"}
                            sx={{
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "10px",
                            }}
                        >
                            <FormControl fullWidth>
                                <InputLabel id="request-select">Request For</InputLabel>
                                <Select
                                    labelId="request-select"
                                    id="request-select"
                                    fullWidth
                                    value={callWindowRequestFor || ""}
                                    onChange={(e) => setCallWindowRequestFor(e?.target?.value)}
                                    label="Request For"
                                    size="small"
                                    displayEmpty
                                    sx={{
                                        width: "50%",
                                    }}
                                >
                                    {requestList.map(({ label, value }) => (
                                        <MenuItem key={label} value={value}>
                                            {label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Stack>
                    )}
                    
                    {user?.voiceInfo?.userType === "reseller" && (
                        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                            <Stack direction={"row"} gap={1}>
                                <IconButton onClick={() => handleReset("callWindow")}>
                                    <Iconify icon="ix:reset" />
                                </IconButton>
                                <LoadingButton
                                    loading={callWindowloader}
                                    variant="contained"
                                    sx={{ width: "100px" }}
                                    onClick={() => handleSubmit("callWindow")}
                                >
                                    Submit
                                </LoadingButton>
                            </Stack>
                        </Box>
                    )}
                </Stack>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    gap: "6px",
                    mb: "15px",
                    border: "0.5px dashed",
                    borderColor: "gray.400",
                    borderRadius:"7px",
                    padding: "12px",
                    paddingTop: "14px"
                }}
            >
                <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Announcement Upload Limit"
                    variant="outlined"
                    InputProps={{
                        sx: inputSx,
                    }}
                    value={anouncementUploadLimit}
                    onChange={(e) => setAnouncementUploadLimit(e.target.value)}
                    size="small"
                />
                {user?.voiceInfo?.userType === "reseller" && (
                    <Stack
                        gap={2}
                        direction={"row"}
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        <FormControl fullWidth>
                            <InputLabel id="request-select">Request For</InputLabel>
                            <Select
                                labelId="request-select"
                                id="request-select"
                                value={uploadLimitRequestFor || ""}
                                onChange={(e) => setUpdateLimitRequestFor(e?.target?.value)}
                                label="Request For"
                                size="small"
                                displayEmpty
                            >
                                {requestList.map(({ label, value }) => (
                                    <MenuItem key={label} value={value}>
                                        {label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Stack>
                )}
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Stack direction={"row"} gap={1}>
                        <IconButton onClick={() => handleReset("announcementLimit")}>
                            <Iconify icon="ix:reset" />
                        </IconButton>
                        <LoadingButton
                            loading={announcementLimitLoader}
                            variant="contained"
                            sx={{ width: "100px" }}
                            onClick={() => handleSubmit("announcementLimit")}
                        >
                            Submit
                        </LoadingButton>
                    </Stack>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    gap: "6px",
                    mb: "15px",
                    border: "0.5px dashed",
                    borderColor: "gray.400",
                    borderRadius:"7px",
                    padding: "12px",
                    paddingTop: "14px"
                }}
            >
                <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Direct Amount Assignment"
                    variant="outlined"
                    InputProps={{
                        sx: inputSx,
                    }}
                    value={uploadDirectAmount}
                    onChange={(e) => setUploadDirectAmount(e.target.value)}
                    size="small"
                />
                {user?.voiceInfo?.userType === "reseller" && (
                    <Stack
                        gap={2}
                        direction={"row"}
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        <FormControl fullWidth>
                            <InputLabel id="request-select">Request For</InputLabel>
                            <Select
                                labelId="request-select"
                                id="request-select"
                                value={uploadDirectAmountRequestFor || ""}
                                onChange={(e) => setUploadDirectAmountRequestFor(e?.target?.value)}
                                label="Request For"
                                size="small"
                                displayEmpty
                            >
                                {requestList.map(({ label, value }) => (
                                    <MenuItem key={label} value={value}>
                                        {label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Stack>
                )}
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Stack direction={"row"} gap={1}>
                        <IconButton onClick={() => handleReset("directAmountAssignment")}>
                            <Iconify icon="ix:reset" />
                        </IconButton>
                        <LoadingButton
                            loading={announcementLimitLoader}
                            variant="contained"
                            sx={{ width: "100px" }}
                            onClick={() => handleSubmit("directAmountAssignment")}
                        >
                            Submit
                        </LoadingButton>
                    </Stack>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    gap: "6px",
                    mb: "15px",
                    border: "0.5px dashed",
                    borderColor: "gray.400",
                    borderRadius:"7px",
                    padding: "12px",
                    paddingTop: "14px"
                }}
            >
                <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Hirarchy Amount Assignment"
                    variant="outlined"
                    InputProps={{
                        sx: inputSx,
                    }}
                    value={uploadHirarchyAmount}
                    onChange={(e) => setuploadHirarchyAmount(e.target.value)}
                    size="small"
                />
              
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Stack direction={"row"} gap={1}>
                        <IconButton onClick={() => handleReset("hirarchyAmountAssignment")}>
                            <Iconify icon="ix:reset" />
                        </IconButton>
                        <LoadingButton
                            loading={announcementLimitLoader}
                            variant="contained"
                            sx={{ width: "100px" }}
                            onClick={() => handleSubmit("hirarchyAmountAssignment")}
                        >
                            Submit
                        </LoadingButton>
                    </Stack>
                </Box>
            </Box>
        </Box>
        </>
    );
}

export default BroadcastSettings